import { Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { FormControlLabel } from 'Features/Project/WorkcentreModal/FormControlLabel/FormControlLabel.view'
import {
  isAllWorkcentresSelected,
  isSomeWorkCentresSelected,
} from 'Features/Project/WorkcentreModal/WorkcentreModal.utils'
import {
  StyledAccordionSummary,
  StyledCheckbox,
} from './AccordionSummary.styles'

export const AccordionSummary = ({
  sourceSiteData,
  handleCheckboxChange,
  readOnly,
}: any) => {
  return (
    <StyledAccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls={sourceSiteData.siteLabel}
    >
      {readOnly ? (
        <Typography>{sourceSiteData.siteLabel}</Typography>
      ) : (
        <FormControlLabel
          label={sourceSiteData.siteLabel}
          control={
            <StyledCheckbox
              checked={isAllWorkcentresSelected(sourceSiteData.siteWorkcentres)}
              indeterminate={isSomeWorkCentresSelected(
                sourceSiteData.siteWorkcentres
              )}
              onChange={(event) =>
                handleCheckboxChange(event, sourceSiteData.siteLabel)
              }
            />
          }
        />
      )}
    </StyledAccordionSummary>
  )
}
